import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import {computed} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "OperatorApplicationFreeDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    siteId: {}
  },
  setup(__props: any) {

let props = __props;

function onVisibleChange(value: boolean) {
    if (!value) {
        OperatorAccountStore.SET_SHOW_FREE_DIALOG_FOR_SITE_ID(null);
    }
}

let iframeSrc = computed(() => {
    let orgId = OperatorAccountStore.data.value.orgId;
    let languageId = OperatorApplicationConfigInstance.languageId;
    return `https://me-talk.ru/json/anonymous/online/paidVersionAdvertise/${orgId}/${props.siteId}/${languageId}`;
});


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    title: _unref(__)('Настало время апгрейда'),
    "onUpdate:modelValue": onVisibleChange,
    class: "full-height-body right no-padding body-overflow-hidden"
  }, {
    default: _withCtx(() => [
      _createElementVNode("iframe", { src: _unref(iframeSrc) }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})